module.exports = __webpack_public_path__ + "gr.svg?a69193c324ff6664634205efe897ea1d";